/** Tiny facility-layer helpers for Pin the work. No map overlay imports. */

export const PIN_MAP_FACILITY_LAYERS = [
  'all',
  'well',
  'swd',
  'rig',
  'gp',
  'tb',
  'fs',
  'cs',
  'gs',
  'cp',
  'rf',
  'tp',
  'inj',
  'plg',
  'plc',
  'plw',
  'ggs',
  'mgs',
  'wh',
  'bw',
  'pit',
  'bgt',
  'wm',
  'rfl',
  'rm',
  'ab',
  'sc',
  'ci',
  'facility',
  'taco',
] as const;

export type PinMapFacilityLayer = (typeof PIN_MAP_FACILITY_LAYERS)[number];

export function nextPinMapFacilityLayer(
  current: string,
  presentTypes: readonly string[] = [],
): PinMapFacilityLayer {
  const present = new Set(presentTypes.map((t) => t.toLowerCase()));
  const cycle = PIN_MAP_FACILITY_LAYERS.filter(
    (id) => id === 'all' || present.size === 0 || present.has(id),
  );
  const list = cycle.length ? cycle : PIN_MAP_FACILITY_LAYERS;
  const idx = list.indexOf(current as PinMapFacilityLayer);
  return list[(idx + 1) % list.length];
}

export function sitePinMatchesFacilityLayer(
  hit: { type?: string; facilityType?: string },
  layer: string,
): boolean {
  if (!layer || layer === 'all') return true;
  const raw = `${hit.facilityType || ''} ${hit.type || ''}`.toLowerCase();
  if (layer === 'well') return /\bwells?\b/.test(raw) && !raw.includes('swd');
  if (layer === 'swd') return raw.includes('swd');
  if (layer === 'rig') return raw.includes('rig');
  if (layer === 'facility') return raw.includes('facility');
  return raw.includes(layer.toLowerCase());
}
